import { PreisIndikation, TariffSelectionCardData } from '@mwe/models';

export function getContractStartInfoFromPriceIndications(tariffKey: string, priceIndications: PreisIndikation[]): string {
  const matchingPriceIndication = findMatchingPreisIndication(tariffKey, priceIndications);
  return getProductAttributeStartDateLongText(matchingPriceIndication);
}

export function getContractStartInfoFromTariffs(tariffKey: string, selectedTariffs: TariffSelectionCardData[]): string {
  const matchingSelectedTariff = findMatchingSelectedTariff(tariffKey, selectedTariffs);
  return getProductAttributeStartDateLongText(matchingSelectedTariff?.priceIndication);
}
function findMatchingSelectedTariff(tarifKey: string, selectedTariffs: TariffSelectionCardData[]): TariffSelectionCardData {
  return selectedTariffs?.find(selectedTariff => selectedTariff?.tariffKey === tarifKey);
}

function findMatchingPreisIndication(tariffKey: string, priceIndications: PreisIndikation[]): PreisIndikation {
  return priceIndications?.find(priceIndication => priceIndication?.tarif?.ISUTarifKey === tariffKey);
}

function getProductAttributeStartDateLongText(matchingPreisindication: PreisIndikation): string {
  return matchingPreisindication?.preisbestandteile?.produktAttribute?.find(produktAttribut => produktAttribut?.name === 'Vertragsbeginn')
    ?.langWert;
}
